import EditarNombre from './componentes/editarNombre';
import EditarAlmacenes from './componentes/editarAlmacenes';
import EditarAlmacenPrincipal from './componentes/editarAlmacenPrincipal';

const Datos = ({ nombre, almacenes, almPrincipal, rol, onModalSubmit }) => {
  const editarNombre =()=>{
    if (rol === "admin"){
      return(
        <EditarNombre 
          onModalSubmit={onModalSubmit}
        />)
    }
  }
  const editarAlmacenes =()=>{
    if (rol === "admin"){
      return(
      <EditarAlmacenes 
        onModalSubmit={onModalSubmit}
        almacenes={almacenes}
      />)
    }
  }
  const editarAlmacenPrincipal =()=>{
    if (rol === "admin"){
      return(
      <EditarAlmacenPrincipal 
        onModalSubmit={onModalSubmit}
        almacenes={almacenes}
      />)
    }
  }

  return (
    <section className='settingsCard'>
      <div className='settingsCardHeader'>
        <div>
          <h2>Datos del rancho</h2>
          <p>Información principal de tu operación.</p>
        </div>
      </div>
      <div className='settingsRows'>
        <div className='settingsRow'>
          <span className='settingsLabel'>Nombre del rancho</span>
          <div className='settingsValue'>{nombre || 'Sin nombre'} {editarNombre()}</div>
        </div>
        <div className='settingsRow settingsRowTop'>
          <span className='settingsLabel'>Almacenes</span>
          <div className='settingsValue'>
            <div className='settingsTags'>
              {almacenes.map((item, index) => <span className='settingsTag' key={index}>{item}</span>)}
            </div>
            {editarAlmacenes()}
          </div>
        </div>
        <div className='settingsRow'>
          <span className='settingsLabel'>Almacén principal</span>
          <div className='settingsValue'>{almPrincipal || 'Sin definir'} {editarAlmacenPrincipal()}</div>
        </div>
      </div>
    </section>
  );
};

export default Datos;
